import { AsyncActionHandler } from 'action-handler';
import { setOsPermission } from 'actions/gallery';

export default new AsyncActionHandler({
  name: 'enable_os_permission',
  handler: (permissionType, { appName }) => async (dispatch) => {
    const { requestStatus } = await window.__webview_comms__.request(
      'enable-os-permission',
      {
        appName,
        osPermissionType: permissionType
      }
    );

    dispatch(setOsPermission(permissionType, requestStatus));
  }
});
